module.exports = __webpack_public_path__ + "img/uk.9a3d48c2.png";